import styled from "styled-components";

export const ExerciseWeeklyItem = styled.li`
  display: grid;
  width: 100%;
  height: 70px;
  background: ${(props) => props.theme.colors.white100};
  border-radius: 10px;
  box-shadow: ${(props) => props.theme.shadows.box};
  align-items: center;
  grid-template-columns: auto 60px;

  &:active {
    background: ${(props) => props.theme.colors.white38};
  }
`;

export const ItemTitBox = styled.div`
  display: grid;
  width: 100%;
  align-items: center;
  grid-template-columns: 70px auto;
`;

export const ItemImgBox = styled.div`
  overflow: hidden;
  width: 70px;
  height: 70px;
  background: ${(props) => props.theme.colors.black10};
  border-radius: 10px 0 0 10px;

  img {
    width: 70px;
    height: 70px;
    object-fit: cover;
    object-position: center;
  }
  mask-image: linear-gradient(
    to bottom,
    transparent 0%,
    #000 40%,
    #000 60%,
    transparent 100%
  );
`;

export const ItemTit = styled.div`
  display: flex;
  height: 70px;
  padding-left: 16px;
  font-size: 1.6rem;
  font-weight: 700;
  justify-content: center;
  flex-direction: column;
  gap: 6px;

  .textUpperBox {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 5px;
    font-size: 8px;
    font-weight: 400;
    color: #b4b4bf;

    p {
      font-size: 1.2rem;
      font-weight: 400;
      color: #797d8e;
    }
  }

  span {
    color: ${(props) => props.theme.colors.primary100};
    font-size: 1.2rem;
    font-weight: 400;
  }
`;

export const ItemArrow = styled.div`
  display: flex;
  width: 100%;
  height: 70px;
  align-items: center;
  justify-content: center;

  svg {
    path {
      fill: ${(props) => props.theme.colors.lightgray100};
      fill-opacity: 1;
    }
  }
`;
